<template>
	<div>
		<div class="header-area" style=" position: relative;">
		<!-- <div ref="nav" class="ui fixed inverted stackable pointing menu" :class="{'transparent':$route.name==='home' && clientSize.clientWidth>768}"> -->
			<!-- <div ref="nav" class="ui inverted stackable menu" style="border: 0 solid transparent;background: #2c3e50;box-shadow: none;margin: 0;border-radius: 0;">
				<div class="ui container" style="height: 48px;">
					<router-link to="/home" class="item" :class="{'m-mobile-hide': mobileHide,'active':$route.name==='home'}">
						<i class="home icon"></i>首页
					</router-link>
					<el-dropdown trigger="click" @command="categoryRoute">
						<span class="el-dropdown-link item" :class="{'m-mobile-hide': mobileHide,'active':$route.name==='category'}">
							<i class="idea icon"></i>分类<i class="caret down icon"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item :command="category.name" v-for="(category,index) in categoryList" :key="index">{{ category.name }}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<router-link to="/archives" class="item" :class="{'m-mobile-hide': mobileHide,'active':$route.name==='archives'}">
						<i class="clone icon"></i>归档
					</router-link>
					<router-link to="/moments" class="item" :class="{'m-mobile-hide': mobileHide,'active':$route.name==='moments'}">
						<i class="comment alternate outline icon"></i>动态
					</router-link>
					<router-link to="/friends" class="item" :class="{'m-mobile-hide': mobileHide,'active':$route.name==='friends'}">
						<i class="users icon"></i>友人帐
					</router-link>
					<router-link to="/about" class="item" :class="{'m-mobile-hide': mobileHide,'active':$route.name==='about'}">
						<i class="info icon"></i>关于我
					</router-link>
				</div>
				
			</div> -->
			<div ref="stickyHeader" class="sticky-header">
				<div class="secContainer">
					<div class="menu-full-wrap">
						<div class="site-branding">
							<router-link to="/home" class="dark-logo">
								<img width="538" height="84" src="../../assets/images/logo.png" class="attachment-full size-full wp-post-image" alt="">
							</router-link>
							<router-link to="/home" class="light-logo">
								<img width="538" height="84" src="../../assets/images/logo.png" class="attachment-full size-full wp-post-image" alt="" >
							</router-link>
						</div>
						<div class="menu-wrap">
							<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelectItem">
								<el-menu-item index="1">Home</el-menu-item>
								<el-menu-item index="2">CRM Listing</el-menu-item>
								<el-menu-item index="3">Blog &amp; News</el-menu-item>
								<!-- <el-menu-item index="4">Contact Us</el-menu-item>
								<el-menu-item index="5">Comment Deletion History</el-menu-item> -->
							</el-menu>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="rt-header-menu mean-container" id="meanmenu" style=""> 
				<div class="mobile-mene-bar">
				<div class="mean-bar">
					<span class="sidebarBtn ">
						<span class="bar"></span>
						<span class="bar"></span>
						<span class="bar"></span>
						<span class="bar"></span>
					</span>
					<router-link to="/home" class="mobile-logo dark-logo">
						<img width="538" height="84" src="../../assets/images/logo.png" class="attachment-full size-full wp-post-image" alt="">
					</router-link>					<router-link to="/home" class="mobile-logo light-logo">
						<img width="538" height="84" src="../../assets/images/logo.png" class="attachment-full size-full wp-post-image" alt="" >
					</router-link>
					<el-drawer
						:visible.sync="drawer"
						direction="ttb"
						:before-close="handleClose"
						:with-header="false"
						:modal="false">
						<nav class="menu-main-menu-container">
							<ul id="menu-main-menu-1" class="menu">
								
								<li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-111 current_page_item menu-item-122 menu-item-parent">
									<router-link to="/home">Home</router-link>
								</li>
								<li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-7325 menu-item-parent">
									<router-link to="/category/Customer Relationship Management (CRM)">CRM Listing</router-link>
								</li>
								<li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-252 menu-item-parent">
									<router-link to="/blogs">Blog &amp; News</router-link>
								</li>
								<!-- <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-418 menu-item-parent">
									<router-link to="/blogs">Contact Us</router-link>
								</li>
								<li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-7402 menu-item-parent">
									<router-link to="/blogs">Comment Deletion History</router-link>
								</li> -->
							</ul>
						</nav>
					</el-drawer>
				</div>    
				
			</div>
		</div>
	</div>
</template>

<script>
	import {getSearchBlogList} from "@/api/blog";
	import {mapState} from 'vuex'
	import {getBlogsCategory} from "@/api/category";

	export default {
		name: "Nav",
		props: {
			// blogName: {
			// 	type: String,
			// 	required: true
			// },
			// categoryList: {
			// 	type: Array,
			// 	required: true
			// },
		},
		data() {
			return {
				mobileHide: true,
				queryString: '',
				queryResult: [],
				timer: null,
				activeIndex: "1",
				categoryList:[],
				drawer: false
			}
		},
		computed: {
			...mapState(['clientSize'])
		},
		watch: {
			//路由改变时，收起导航栏
			'$route.path'() {
				this.mobileHide = true
			}
		},
		beforeDestroy() {
			window.removeEventListener("scroll", this.handleScroll);
			if (this.sidebarBtn) {
				this.sidebarBtn.removeEventListener("click", this.toggleMenu);
			}
		},
		mounted() {
			window.addEventListener("scroll", this.handleScroll);
			//监听页面滚动位置，改变导航栏的显示
			// window.addEventListener('scroll', () => {
			// 	//首页且不是移动端
			// 	if (this.$route.name === 'home' && this.clientSize.clientWidth > 768) {
			// 		if (window.scrollY > this.clientSize.clientHeight / 2) {
			// 			this.$refs.nav.classList.remove('transparent')
			// 		} else {
			// 			this.$refs.nav.classList.add('transparent')
			// 		}
			// 	}
			// })
			//监听点击事件，收起导航菜单
			document.addEventListener('click', (e) => {
				//遍历冒泡
				let flag = e.path.some(item => {
					if (item === this.$refs.nav) return true
				})
				//如果导航栏是打开状态，且点击的元素不是Nav的子元素，则收起菜单
				if (!this.mobileHide && !flag) {
					this.mobileHide = true
				}
			})
			this.sidebarBtn = document.querySelector(".sidebarBtn");
			this.meanmenu = document.getElementById("meanmenu");

			if (this.sidebarBtn) {
				this.sidebarBtn.addEventListener("click", this.toggleMenu);
			}
		},
		created(){
			this.getBlogsCategories()
		},
		methods: {
			handleClose(done) {
				this.drawer = false
				const meanmenu = document.getElementById("meanmenu");
				if (meanmenu) {
					meanmenu.classList.remove("slidemenuon"); 
				}
				if (typeof done === "function") {
					done();
				}
     		},
			toggleMenu() {
				if (this.meanmenu) {
					this.meanmenu.classList.toggle("slidemenuon");
					this.drawer = this.meanmenu.classList.contains("slidemenuon");
				}
			},
			getBlogsCategories() {
				getBlogsCategory().then(res => {
					if(res.code == 200){
						this.categoryList = res.data
					}
				}).catch(() => {
					this.msgError("请求失败")
				})
			},
			handleScroll() {
				const stickyHeader = this.$refs.stickyHeader;
				const offsetTop = stickyHeader.offsetTop; 
				if (window.scrollY > offsetTop ) {
					stickyHeader.style.position = "fixed";
					stickyHeader.style.top = "0";
					stickyHeader.style.width = "100%";
					stickyHeader.style.zIndex = "1000";
					stickyHeader.style.background = "#fff";
					stickyHeader.style.transition = "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out"
					stickyHeader.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.1)"
				} else {
					stickyHeader.style.position = "relative";
					stickyHeader.style.boxShadow = "none";
				}
			},
			toggle() {
				this.mobileHide = !this.mobileHide
			},
			categoryRoute(name) {
				this.$router.push(`/category/${name}`)
			},
			debounceQuery(queryString, callback) {
				this.timer && clearTimeout(this.timer)
				this.timer = setTimeout(() => this.querySearchAsync(queryString, callback), 1000)
			},
			querySearchAsync(queryString, callback) {
				if (queryString == null
						|| queryString.trim() === ''
						|| queryString.indexOf('%') !== -1
						|| queryString.indexOf('_') !== -1
						|| queryString.indexOf('[') !== -1
						|| queryString.indexOf('#') !== -1
						|| queryString.indexOf('*') !== -1
						|| queryString.trim().length > 20) {
					return
				}
				getSearchBlogList(queryString).then(res => {
					if (res.code === 200) {
						this.queryResult = res.data
						if (this.queryResult.length === 0) {
							this.queryResult.push({title: '无相关搜索结果'})
						}
						callback(this.queryResult)
					}
				}).catch(() => {
					this.msgError("请求失败")
				})
			},
			handleSelect(item) {
				if (item.id) {
					this.$router.push(`/${item.title}`)
				}
			},
			handleSelectItem(index){
				if(index == 1){
					this.$router.push("/home")
				}else if(index == 2){
					this.$router.push("/category/Customer Relationship Management (CRM)")
				}else if(index == 3){
					this.$router.push("/blogs")
				}
			}
		}
	}
</script>

<style>
	.container {
		width: 1400px !important;
		margin-left: auto !important;
		margin-right: auto !important;
		display: flex;
		justify-content: flex-end;
	}

	.ui.fixed.menu {
		transition: .3s ease-out;
	}

	.ui.inverted.pointing.menu.transparent {
		background: transparent !important;
	}

	.ui.inverted.pointing.menu.transparent .active.item:after {
		background: transparent !important;
		transition: .3s ease-out;
	}

	.ui.inverted.pointing.menu.transparent .active.item:hover:after {
		background: transparent !important;
	}

	.el-dropdown-link {
		outline-style: none !important;
		outline-color: unset !important;
		height: 100%;
		cursor: pointer;
	}

	.el-dropdown-menu {
		margin: 7px 0 0 0 !important;
		padding: 0 !important;
		border: 0 !important;
		background: #2c3e50 !important;
	}

	.el-dropdown-menu__item {
		padding: 0 15px !important;
		color: rgba(255, 255, 255, .9) !important;
	}

	.el-dropdown-menu__item:hover {
		background: rgba(255, 255, 255, .08) !important;
	}

	.el-popper .popper__arrow::after {
		content: none !important;
	}

	.popper__arrow {
		display: none !important;
	}

	/* .m-search {
		min-width: 220px;
		padding: 0 !important;
	}

	.m-search input {
		color: rgba(255, 255, 255, .9);;
		border: 0px !important;
		background-color: inherit;
		padding: .67857143em 2.1em .67857143em 1em;
	}

	.m-search i {
		color: rgba(255, 255, 255, .9) !important;
	}

	.m-search-item {
		min-width: 350px !important;
	}

	.m-search-item li {
		line-height: normal !important;
		padding: 8px 10px !important;
	}

	.m-search-item li .title {
		text-overflow: ellipsis;
		overflow: hidden;
		color: rgba(0, 0, 0, 0.87);
	}

	.m-search-item li .content {
		text-overflow: ellipsis;
		font-size: 12px;
		color: rgba(0, 0, 0, .70);
	} */
	.sticky-header {
		position: sticky;
		top: 0; 
		background-color: #fff;
		color: white;
		text-align: center;
		padding: 10px;
		font-size: 16px;
		font-weight: bold;
		z-index: 1000;
		height: 98px;
		display: flex;
		align-items: center;
	}
	@media (min-width: 1400px) {
		.secContainer {
			max-width: 1200px !important;
		}
	}
	/* @media (min-width: 1400px) {
		.secContainer, .secContainer-lg, .secContainer-md, .secContainer-sm, .secContainer-xl, .secContainer-xxl {
			max-width: 1320px;
		}
	}
	@media (min-width: 1200px) {
		.secContainer, .secContainer-lg, .secContainer-md, .secContainer-sm, .secContainer-xl {
			max-width: 1140px;
		}
	}
	@media (min-width: 992px) {
		.secContainer, .secContainer-lg, .secContainer-md, .secContainer-sm {
			max-width: 960px;
		}
	}
	@media (min-width: 768px) {
		.secContainer, .secContainer-md, .secContainer-sm {
			max-width: 720px;
		}
	}
	@media (min-width: 576px) {
		.secContainer, .secContainer-sm {
			max-width: 540px;
		}
	}  */
	.secContainer, .secContainer-fluid, .secContainer-lg, .secContainer-md, .secContainer-sm, .secContainer-xl, .secContainer-xxl {
		width: 100%;
		padding-right: var(--bs-gutter-x, .75rem);
		padding-left: var(--bs-gutter-x, .75rem);
		margin-right: auto;
		margin-left: auto;
	}
	.menu-full-wrap {
		display: flex;
		justify-content: space-between;
		align-items: center;
		
	}
	.site-branding a {
		display: table-cell;
		vertical-align: middle;
		color: #2c3e50;
		font-size: 30px;
		font-weight: 700;
		text-transform: capitalize;
	}
	a:visited {
		transition: allease 0.31s;
		text-decoration: none;
	}
	.site-branding .light-logo {
		display: none;
	}
	.site-branding a img {
		max-width: 250px;
		width: 100%;
		height: auto;
	}
	.menu-main-menu-container{
		display: block;
	}
	.el-menu.el-menu--horizontal {
		border: none !important;
		display: flex;
		flex-wrap: nowrap;
	}
	/* .el-menu--horizontal>>>.el-menu-item:not(.is-disabled):hover {
		background:transparent !important;
		color: #fff !important;
		border-bottom: 1px solid #fff !important;
	} */
	.el-menu-item {
		position: relative;
		overflow: hidden; /* 防止下划线溢出 */
		border-bottom: none !important;
		font-size: 17px !important;
		font-weight: bold !important;
		font-style: normal !important;
		color:#303133 !important;
	}

	.el-menu-item::after {
		content: "";
		position: absolute;
		bottom: 0;
		left: 0;
		width: 0%; /* 默认宽度为 0，不显示下划线 */
		height: 2px; /* 下划线的高度 */
		background-color: #000; /* 下划线的颜色 */
		transition: none; /* 不需要过渡 */
	}

	.el-menu-item:hover::after {
		width: 20%; /* 鼠标悬停时，下划线宽度为 20% */
		animation: slideUnderline 0.6s forwards; /* 运行动画 */
	}

	@keyframes slideUnderline {
		0% {
			left: 0;
			width: 0%; /* 从左侧开始，宽度为 0 */
		}
		100% {
			left: 70%; /* 结束时，下划线停在右侧的 20% 处 */
			width: 20%; /* 宽度为 20% */
		}
	}

	.el-menu--horizontal>.el-menu-item.is-active {
		border-bottom: none !important;
		color: #303133;
	}
	@media only screen and (max-width: 991px) {
		.header-area {
			display: none;
		}
	}
	@media only screen and (min-width: 992px) {
		#meanmenu {
			display: none;
		}
	}
	.menu-wrap{
		display: flex;
		flex-wrap: nowrap;
	}
	.mean-bar {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
		background: #fff;
		float: none;
		position: relative;
		padding: 10px 12px;
		top: 0;
		left: 0;
		width: 100%;
	}
	.mobile-logo img {
		max-width: 130px;
		height:auto;
	}
	.mean-bar .light-logo {
		display: none;
	}
	.mean-bar .sidebarBtn {
		display: block;
		cursor: pointer;
		transition: all ease 0.31s;
		font-size: 20px;
    	color: #161f38;
	}
	.mean-bar .sidebarBtn .bar {
		background: #777777;
		height: 2px;
		width: 25px;
		display: block;
		margin-bottom: 3px;
		transition: all ease 0.31s;
	}
	.mean-bar .sidebarBtn .bar:nth-child(2), .mean-bar .sidebarBtn .bar:nth-child(3) {
		width: 20px;
	}
	.slidemenuon .sidebarBtn .bar:nth-child(1) {
		transform: rotate(45deg) translate(3px, 8px);
	}
	.slidemenuon .sidebarBtn .bar:nth-child(2), .slidemenuon .sidebarBtn .bar:nth-child(3) {
		opacity: 0;
	}
	.slidemenuon .sidebarBtn .bar:nth-child(4) {
		transform: rotate(-45deg) translate(3px, -8px);
	}
	.el-drawer.ttb{
		top:45px !important;
		width: 97% !important;
		margin: 0 auto;
		height:130px !important;
		border-radius: 10px;
	}

	.menu-main-menu-container {
		display: block;
	}
	nav > ul {
		padding-top: 10px;
		padding-bottom: 10px;
	}
	.menu-main-menu-container ul {
		list-style-type: none;
		margin: 0;
		padding: 0;
	}

	.menu-main-menu-container ul li {
		position: relative;
	}

	.menu-main-menu-container ul li > a {
		font-family: 'Inter', sans-serif;
		font-size: 17px;
		line-height: 22px;
		font-weight: bold;
		text-decoration: none;
		padding: 10px 12px;
		background: #fff;
		display: block;
		position: relative;
		color: #333;
		transition: color 0.3s ease;
	}

	.menu-main-menu-container ul li > a:before {
		content: "";
		position: absolute;
		left: 12px;
		top: 40%;
		width: 3px;
		height: 100%;
		background: #000;
		opacity: 0;
		visibility: hidden;
		transition: all ease 0.2s;
	}

	.menu-main-menu-container ul li:hover > a:before {
		visibility: visible;
		opacity: 1;
		height: 10px;
	}

	.menu-main-menu-container ul li:hover > a {
		color: #2c3e50;
		padding-left: 24px;
	}

</style>